module.exports = __webpack_public_path__ + "static/img/arrow_right_sm.75e2206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010102/arrow_right_sm.png
// module id = ayPv
// module chunks = 10